import React, { useEffect, useMemo, useRef } from 'react';

import { StylesManager, Model } from 'survey-core';
import { Survey } from 'survey-react-ui';

import QuestionsJSON from '../Questions.json';
import './SurveyReact.css';
// import 'survey-core/defaultV2.min.css';
import './defaultV2.css';
import toSurveryData from './toSurveryData';

StylesManager.applyTheme('defaultV2');

function loadState(survey, res) {
  if (res.data) survey.data = toSurveryData(res.data);
  const page = Number(res.currentPageNo);
  if (Number.isInteger(page) && page >= 0 && page < survey.pageCount) {
    survey.currentPageNo = page;
  }
}

function SurveyReact({
  onPageChanged,
  onValueChanged,
  onComplete,
  onValidatedErrorsOnCurrentPage,
  defaultValue,
}) {
  // Save-status rerenders must not recreate the model and discard current input.
  const survey = useMemo(() => new Model(QuestionsJSON), []);
  const callbacks = useRef({});
  callbacks.current = { onPageChanged, onValueChanged, onComplete, onValidatedErrorsOnCurrentPage };

  useEffect(() => {
    if (defaultValue) {
      loadState(survey, defaultValue);
    }
    // eslint-disable-next-line
  }, [defaultValue]);

  useEffect(() => {
    const events = [
      [survey.onCurrentPageChanged, 'onPageChanged'],
      [survey.onValueChanged, 'onValueChanged'],
      [survey.onComplete, 'onComplete'],
      [survey.onValidatedErrorsOnCurrentPage, 'onValidatedErrorsOnCurrentPage'],
    ];
    const handlers = events.map(([event, key]) => {
      const handler = (sender, options) => {
        if (typeof callbacks.current[key] === 'function') callbacks.current[key](sender, options);
      };
      event.add(handler);
      return [event, handler];
    });
    return () => handlers.forEach(([event, handler]) => event.remove(handler));
  }, [survey]);

  return (
    <>
      <Survey
        model={survey}
        style={{ paddingTop: '10px', marginBottom: 20 }}
        showProgressBar="top"
        progressBarType="pages"
        focusFirstQuestionAutomatic={false}
        showCompletedPage={false}
      />
    </>
  );
}

export default SurveyReact;

